export const HEADER_KEY_AUTHORIZATION: string = 'Authorization';
export const HEADER_KEY_DEVICE_ID: string = 'Device-ID';
export const HEADER_KEY_TIMEZONE_OFFSET: string = 'Timezone-Offset';
export const HEADER_KEY_APOLLO_REQUIRE_PREFLIGHT: string = 'Apollo-Require-Preflight';
